import * as React from 'react';
import '../css/SuperUserPageView.css';
import HeaderBar from '../../HeaderBar/HeaderBar';
import TaglinesTable from './TaglinesTable'

export interface IManageTaglinesProps {
}

export interface IManageTaglinesState {

}

export default class ManageTaglines extends React.Component<IManageTaglinesProps, IManageTaglinesState> {
  render() {

	return (
	  <div className="root-container">
		<HeaderBar />
		<div className="inner-su-container">
			<TaglinesTable/>
		</div>
	  </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageTaglines.tsx